<template>
  <div class="MyRank fs20">
    <div class="tb">
      <div v-for="(v, k) in info" class="column">
        <div>{{k}}</div>
        <div>{{v}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MyRank',
   props: ['info'],
   computed: {
     /* info() {*/
     /* return this.$store.state.score.myrank*/
     /* }*/
   }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .MyRank{
   background-image: url(~@/assets/image/score/bg-myrank.png);
   background-size: 62.3vw;
   width: 62.3vw;
   height: 10.73vw;
   margin-left: auto;
   margin-right: auto;
   margin-top: 5.3vw;
   padding-top: 1.1vw;
   box-sizing: border-box;
   color: white;
 }
 .tb{
   margin-left: 12.35vw;
   margin-right: 5.5vw;
   display: flex;
   height: 6.5vw;
 }
 .column{
   flex-grow: 1;
   max-width: 10.99vw;
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: space-around;
 }
</style>
